// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1XUjn","type":"styles_type__29nwf","choices":"styles_choices__XgvKE"};